import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';


let CircleLoader = () => {
    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '85vh' }}
        >
            <Grid item xs={3}>
                <CircularProgress
                    size={60}
                    thickness={3}
                />
            </Grid>
        </Grid>
    )
}

export default CircleLoader;